export default "__VITE_ASSET__CLUal959__"